import React from "react";

export const appointmentTimesPayload = (form) => {
  if (!form.ora_inizio && !form.ora_fine) return {};
  if (!form.ora_inizio || !form.ora_fine) throw new Error("Indica sia l’orario di inizio sia quello di fine.");
  if (form.ora_fine <= form.ora_inizio) throw new Error("L’orario di fine deve essere successivo all’inizio.");
  return { ora_inizio: form.ora_inizio, ora_fine: form.ora_fine };
};

export default function PublicTalkAppointmentTimes({ form, onChange }) {
  return <fieldset className="col-span-full rounded-xl border border-blue-100 bg-blue-50/40 p-3">
    <legend className="px-1 text-sm font-semibold text-gray-800">Orari dell’appuntamento</legend>
    <p className="mb-3 text-xs text-gray-600">Lascia vuoti entrambi per usare gli orari della congregazione ospitante. Se non sono configurati, inseriscili qui: valgono solo per questo appuntamento.</p>
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <label className="text-sm font-medium text-gray-700">Ora di inizio
        <input type="time" className="form-input mt-1 min-h-11" required={Boolean(form.ora_fine)} value={form.ora_inizio || ""} onChange={e => onChange({ ora_inizio: e.target.value })} />
      </label>
      <label className="text-sm font-medium text-gray-700">Ora di fine
        <input type="time" className="form-input mt-1 min-h-11" required={Boolean(form.ora_inizio)} value={form.ora_fine || ""} onChange={e => onChange({ ora_fine: e.target.value })} />
      </label>
    </div>
  </fieldset>;
}
